import { ChangeEvent } from "react";
import MpNumberTextField from "src/components/MpTextFieldNumberOnly";
import { useAlerting, useTranslation } from "src/hooks";
import { onlyAllowInteger } from "src/utils/helper";
import { useBatchContractSweepFormContext } from "../../../contexts";

function MaxNumberOfSweepableAddressesNumberTextField({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}) {
  const { translate: t } = useBatchContractSweepFormContext();
  const { alerting } = useAlerting();

  const { tc } = useTranslation("common");
  const label = t("max_number_of_sweepable_addresses");

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = e.target.value;
    const isInteger = onlyAllowInteger(value);
    if (!isInteger) {
      return alerting("warning", t("allowIntOnly"));
    }
    onChange(e);
  };

  return (
    <>
      <div>{label}</div>
      <MpNumberTextField
        value={value}
        label={tc("phInputField", { fieldName: label })}
        onChange={handleChange}
      />
    </>
  );
}

export default MaxNumberOfSweepableAddressesNumberTextField;
